var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 0C3.7835 0 3 0.783502 3 1.75V2C3 2.08488 3.00604 2.16835 3.01772 2.25H0.75C0.335786 2.25 0 2.58579 0 3C0 3.41421 0.335786 3.75 0.75 3.75H1.51772C1.50604 3.83165 1.5 3.91512 1.5 4V10.25C1.5 11.2165 2.2835 12 3.25 12H8.75C9.7165 12 10.5 11.2165 10.5 10.25V4C10.5 3.91512 10.494 3.83165 10.4823 3.75H11.25C11.6642 3.75 12 3.41421 12 3C12 2.58579 11.6642 2.25 11.25 2.25H8.98228C8.99396 2.16835 9 2.08488 9 2V1.75C9 0.783502 8.2165 0 7.25 0H4.75ZM7.25 2.25C7.38807 2.25 7.5 2.13807 7.5 2V1.75C7.5 1.61193 7.38807 1.5 7.25 1.5H4.75C4.61193 1.5 4.5 1.61193 4.5 1.75V2C4.5 2.13807 4.61193 2.25 4.75 2.25H7.25ZM3.25 3.75C3.11193 3.75 3 3.86193 3 4V10.25C3 10.3881 3.11193 10.5 3.25 10.5H8.75C8.88807 10.5 9 10.3881 9 10.25V4C9 3.86193 8.88807 3.75 8.75 3.75H3.25Z",
    fill: "#010311"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashMobileIcon);
export default __webpack_public_path__ + "static/media/trashMobileIcon.0eccdf0745ee21ac03c664a5257e37cb.svg";
export { ForwardRef as ReactComponent };